import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators,} from '@angular/forms';
import {Router} from '@angular/router';
import {SvgIconComponent} from 'angular-svg-icon';
import {ButtonComponent} from '../../../aptem-component-library/components/button/button.component';
import {FormPageComponent} from '../../common/form/form.component';
import {TextInputComponent} from '../../../aptem-component-library/components/text-input/text-input.component';
import {catchError, Observable, of, take} from 'rxjs';
import {SignupApiService} from '../../services/signup-api.service';
import { Location } from '@angular/common';

@Component({
  selector: 'signup',
  templateUrl: './signup-verify.component.html',
  styleUrls: ['./signup-verify.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SvgIconComponent,
    ButtonComponent,
    FormPageComponent,
    TextInputComponent,
    ReactiveFormsModule
],
})
export class SignUpVerifyPageComponent implements OnInit{
  public landingForm: FormGroup;
  protected isSubmitting: boolean = false;
  protected pageHeadingKey: string = 'registration-page-heading';
  protected pageHeadingValue$: Observable<string | null>;
  protected pageBodyKey: string = 'registration-page-body';
  protected pageBodyValue$: Observable<string | null>;
  protected errorMessage: string | null = null;

  constructor(
    private apiService: SignupApiService,
    private router: Router,
    private location: Location) {
    this.landingForm = new FormGroup({
      fullName: new FormControl('', [
        Validators.required,
        Validators.maxLength(500),
        Validators.pattern(/^[a-zA-Z0-9-' ]+$/),
      ]),
      emailAddress: new FormControl('', [
        Validators.required,
        Validators.maxLength(500),
        Validators.email,
      ]),
    });
  }

  ngOnInit(): void {
    const navState = this.location.getState() as { error?: string };
    this.errorMessage = navState.error ?? null;
  }

  onSubmit(): void {
    if (this.landingForm.valid && !this.isSubmitting) {
      this.isSubmitting = true;
      this.processSubmit();
    } else {
      return;
    }
  }

  processSubmit(): void {
    this.apiService
      .verifyEmail(
        this.landingForm.value.fullName,
        this.landingForm.value.emailAddress
      )
      .pipe(
        take(1),
        catchError((err: HttpErrorResponse) => {
          console.log(err);

          if (err.status === 400) {
            const message = typeof err.error.error === 'string' ? err.error.error : err.error?.message;

            this.errorMessage = message === 'Invalid business email provided.'
              ? 'Your request to sign up was not successful. Please try again with a business email address.'
              : 'There was an error processing your request. Please try again.';
          } else {
            this.router.navigate(['/error'], {
              state: { error: 'Unable to signup for a free account.' }
            });
          }

          this.isSubmitting = false;
          return of(null);
        })
      )
      .subscribe((response: HttpResponse<any>) => {
        if (!response) return; // skip success handling if it was an error

        this.landingForm.reset();
        this.landingForm.disable();

        this.router.navigate(['/signup-verify']);

        this.isSubmitting = false;
      });
  }
}
